module.exports = __webpack_public_path__ + "static/portfolio-img3-3d88f46a938a0d33ce0ec35c142032ab.jpg";